export class OrderReservationDto { 
    id = 0;
    amountToApply = 0;
    peopleSoftOpenCashId: string = '';
    invoiceId: number | null = null;
    statusCode = 'O';
}